import React, { useContext, memo } from 'react';
import PropTypes from 'prop-types';
import { TranslatorContext } from '@jutro/locale';
import { Button } from '@jutro/components';
import styles from './VehicleDamagePicker.module.scss';

const DamageList = memo(({ damagedParts, offDamage }) => {
    const translator = useContext(TranslatorContext);
    return (
        <div>
            {damagedParts.map((item) => (
                <div key={item.name}>
                    <span>
                        {translator({
                            id: item.name,
                            defaultMessage: item.name
                        })}
                    </span>
                    <Button
                        id={`damageParts${item.name}`}
                        size="large"
                        type="tertiary"
                        icon="mi-delete"
                        iconPosition={null}
                        className={styles.gw_trash_digital_button}
                        onClick={() => offDamage(item, damagedParts)}
                    />
                </div>
            ))}
        </div>
    );
});
DamageList.propTypes = {
    damagedParts: PropTypes.shape([]).isRequired,
    offDamage: PropTypes.func.isRequired
};

export default DamageList;
